import { Box, Card, Heading, Text, VStack } from '@chakra-ui/react';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'iconoir-react';

interface SuccessHeaderProps {
  payoutScheduleOption: 'asap' | 'scheduled';
  formatScheduledDate: () => string;
}

export const SuccessHeader: React.FC<SuccessHeaderProps> = ({
  payoutScheduleOption,
  formatScheduledDate,
}) => {
  const { t } = useTranslation();

  return (
    <Card.Root
      animation="fadeIn 0.5s ease-out"
      css={{
        '@keyframes fadeIn': {
          from: { opacity: 0, transform: 'translateY(10px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <Card.Body>
        <VStack gap={4} py={4}>
          <Box
            animation="scaleIn 0.5s ease-out"
            css={{
              '@keyframes scaleIn': {
                from: { transform: 'scale(0.8)', opacity: 0 },
                to: { transform: 'scale(1)', opacity: 1 },
              },
            }}
          >
            <CheckCircle width={64} height={64} color="var(--chakra-colors-green-500)" />
          </Box>
          <VStack gap={2} textAlign="center">
            <Heading size="lg">{t('payouts.confirmation.successHeader.title')}</Heading>
            <Text fontWeight="light" fontSize="sm">
              {payoutScheduleOption === 'asap'
                ? t('payouts.confirmation.successHeader.messageAsap')
                : t('payouts.confirmation.successHeader.messageScheduled', {
                    date: formatScheduledDate(),
                  })}
            </Text>
          </VStack>
        </VStack>
      </Card.Body>
    </Card.Root>
  );
};
